export const colors = {
  Black: '#000000',
  Black100: '#373737',
  Blue: '#363BC4',
  Blue02: '#0A0E27',
  Blue02Opacity: '#0A0E2733',
  /** Gradiente de marca 2027 (primária → acento ciano). */
  AccentGradient: 'linear-gradient(107.22deg, #363BC4 29.9%, #00B9CE 123.46%)',
  /** Acento de marca 2027 (ciano); não é cor de estado. */
  Accent: '#00B9CE',
  Green02: '#00D698',
  Grey: '#9C9C9C',
  Grey02: '#EFF1F4',
  Grey03: '#E1E1E1',
  Grey04: '#CAD3E0',
  White: '#FFFFFF',
  Black900: '#0A0D14',
  Green500: '#39B719',
  Grey100: '#F6F8FA',
  Grey200: '#E2E4E9',
  Grey300: '#CDD0D5',
  Grey400: '#868C98',
  Grey500: '#525866',
  Blue700: '#363BC4',
  Blue900: '#0A0E27',
  BlueDark900: '#2A2F86',
  Blue900Opacity: '#0A0E2733',
  Red600: '#DD1818',
  Orange600: '#F28602',
  Soft200: '#E2E4E9',
};
